import React from 'react';
import './StatusAlert.css';
import CloseIcon from '@mui/icons-material/Close';

/**
 * StatusAlert — NoSpinAlert ile aynı modal estetiğinde, tema-aware durum modal'ı.
 *
 * Props:
 *   type        – 'success' | 'error'
 *   title       – opsiyonel; verilmezse type'a göre default ("Başarılı" / "Hata")
 *   message     – ana mesaj (genelde API'den gelen mesaj)
 *   onClose     – kapatma callback'i
 *   confirmLabel– aksiyon butonu yazısı (default "Tamam")
 */
const StatusAlert = ({
  type = 'success',
  title,
  message,
  onClose,
  confirmLabel = 'Tamam',
}) => {
  const defaultTitle = type === 'success' ? 'Başarılı' : 'Hata';

  return (
    <div className="status-overlay" onClick={onClose}>
      <div
        className={`status-modal status-modal-${type}`}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="status-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="status-close" onClick={onClose} aria-label="Kapat">
          <CloseIcon fontSize="small" />
        </button>

        <div className="status-content">
          <div className="status-icon" aria-hidden="true">
            {type === 'success' ? (
              <svg viewBox="0 0 24 24" fill="none">
                <path pathLength="100" d="M5 12.5 L10 17.5 L19 7.5" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none">
                <line x1="5" y1="5" x2="19" y2="19" />
                <line x1="19" y1="5" x2="5" y2="19" />
              </svg>
            )}
          </div>

          <h2 id="status-title" className="status-title">
            {title || defaultTitle}
          </h2>
          <p className="status-message">{message}</p>

          <button
            type="button"
            className={`status-btn status-btn-${type}`}
            onClick={onClose}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusAlert;
